export { default } from "./box-subheading";
